import stateStore from '@/engine/stores/state-store';

import templatesDataStore from '../data/templates.data.store';

const stateUpdates = templatesDataStore
  .updates
  .map(({ items }) => ({ templates: items, loaded: true }));

stateUpdates.onValue(stateStore.Publish('template-admin', 'template-admin-list'));
